import Text from 'components/Text/Text';
import React from 'react';
import breadcrumbs from 'images/breadcrumbs.svg';
import { Button } from 'antd';
import { IItemForGetShortInfo, ServerErrorTypes } from 'types';
import { ICreateDishErrorResponseData } from 'modules/Menu/Dishes/CreateDish/createDishState/createDishContext';
import classNames from 'classnames';
import style from './ModalSentErrorWithInfo.module.scss';

interface IModalSentErrorWithInfo {
	onConsentEvent: () => void;
	isVisible: boolean;
	errorResponseData: ICreateDishErrorResponseData | null;
	fetchedRestaurants: IItemForGetShortInfo[];
	fetchedSuggestedDishes: IItemForGetShortInfo[];
	fetchedAdditionalDishes: IItemForGetShortInfo[];
	fetchedDishModifications: IItemForGetShortInfo[];
}

const ModalSentErrorWithInfo: React.FC<IModalSentErrorWithInfo> = ({
	onConsentEvent,
	isVisible,
	errorResponseData,
	fetchedAdditionalDishes,
	fetchedDishModifications,
	fetchedSuggestedDishes,
	fetchedRestaurants,
}) => {
	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	const getDishType = () => {
		switch (errorResponseData?.errorType) {
			case ServerErrorTypes.SUGGESTED_DISH_VALIDATION_FAILED:
				return { dishes: fetchedSuggestedDishes, label: 'suggestedDishesLabel' };
			case ServerErrorTypes.ADDITIONAL_DISH_VALIDATION_FAILED:
				return { dishes: fetchedAdditionalDishes, label: 'additionalDishesLabel' };
			case ServerErrorTypes.DISH_MODIFICATION_VALIDATION_FAILED:
				return { dishes: fetchedDishModifications, label: 'dishModificationsLabel' };
			default:
				return { dishes: [], label: 'dishesLabel' };
		}
	};

	const dishType = getDishType();

	const getAdditionalInfo = () => {
		return errorResponseData?.Metadata?.restaurants.map((el: { restaurantId: string; dishes: string[] }) => {
			const restaurantName =
				fetchedRestaurants.find((fetchedRestaurant) => fetchedRestaurant.id === el.restaurantId)?.name || null;
			const dishNames: string[] = [];
			for (let i = 0; i < el.dishes.length; i++) {
				for (let j = 0; j < dishType.dishes.length; j++) {
					el.dishes[i] === dishType.dishes[j].id && dishNames.push(dishType.dishes[j].name);
				}
			}
			return (
				<React.Fragment key={el.restaurantId}>
					<Text
						className={style.nameWrapper}
						translationNameSpace="modals"
						translationKey="restaurantDotHaveThis"
						values={{ restaurantName }}
						components={[
							<Text
								key="1"
								translationNameSpace="modals"
								translationKey={dishType.label}
								asFragment={true}
							/>,
						]}
						size="xxl"
						weight="bold"
						align="center"
					/>
					<div className={style.additionalInfoItems}>
						{dishNames.map((dishName) => (
							<div className={style.nameWrapper} key={dishName}>
								<Text
									translationKey={dishName}
									theme="secondaryLight"
									size="l"
									weight="bold"
									withTooltip={true}
								/>
								,
							</div>
						))}
					</div>
				</React.Fragment>
			);
		});
	};

	return (
		<div className={containerClasses}>
			<div className={style.wrapper}>
				<div className={style.closeIconWrapper} onClick={onConsentEvent}>
					<svg className={style.closeIcon}>
						<use xlinkHref={`${breadcrumbs}#resetIcon`} />
					</svg>
				</div>
				<svg className={style.errorIcon}>
					<use xlinkHref={`${breadcrumbs}#error`} />
				</svg>
				<div className={style.description}>{getAdditionalInfo()}</div>
				<div className={style.btnWrapper}>
					<Button className={style.okBtn} onClick={onConsentEvent} type="primary" htmlType="submit">
						<Text translationNameSpace="modals" translationKey="okButton" asFragment={true} />
					</Button>
				</div>
			</div>
		</div>
	);
};

export default React.memo(ModalSentErrorWithInfo);
